// © Euler Junior on Stackoverflow
// From https://stackoverflow.com/a/32257791/3997690

function hex(c) {
    const s = '0123456789abcdef';
    let i = parseInt(c, 10);
    if (i === 0 || isNaN(c)) {
        return '00';
    }
    i = Math.round(Math.min(Math.max(0, i), 255));
    return s.charAt((i - (i % 16)) / 16) + s.charAt(i % 16);
}

// Convert an RGB triplet to a hex string
function convertToHex(rgb) {
    return hex(rgb[0]) + hex(rgb[1]) + hex(rgb[2]);
}

// Remove '#' in color hex string
function trim(s) {
    return s.charAt(0) === '#' ? s.substring(1, 7) : s;
}

// Convert a hex string to an RGB triplet
function convertToRGB(hex) {
    return [
        parseInt(trim(hex).substring(0, 2), 16),
        parseInt(trim(hex).substring(2, 4), 16),
        parseInt(trim(hex).substring(4, 6), 16),
    ];
}

export function generateColorScaleFromHex(colorStart, colorEnd, colorCount) {
    return generateColorScaleFromRGB(convertToRGB(colorStart), convertToRGB(colorEnd), colorCount);
}

export function generateColorScaleFromRGB(start, end, colorCount) {
    const colors = [];
    for (let i = 0; i < colorCount; i++) {
        const t = i / colorCount;
        colors.push(
            convertToHex([
                start[0] * (1 - t) + end[0] * t,
                start[1] * (1 - t) + end[1] * t,
                start[2] * (1 - t) + end[2] * t,
            ]),
        );
    }
    return colors;
}

// CREDIT: https://css-tricks.com/snippets/javascript/lighten-darken-color/
export function adjustColorBrightness(col, amt) {
    let usePound = false;
    if (col[0] === '#') {
        col = col.slice(1);
        usePound = true;
    }
    const num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255) {
        r = 255;
    } else if (r < 0) {
        r = 0;
    }
    let b = ((num >> 8) & 0x00ff) + amt;
    if (b > 255) {
        b = 255;
    } else if (b < 0) {
        b = 0;
    }

    let g = (num & 0x0000ff) + amt;
    if (g > 255) {
        g = 255;
    } else if (g < 0) {
        g = 0;
    }
    return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
}
